import React from 'react';
import { UsersSVG } from '../../../components';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { palette } from '../../../styles/theme';

export default function UsersHeader () {
    const { t } = useTranslation();
    return (
        <Box
            display='flex'
            alignItems='center'

            style={{ height: '58px' }}>
            <Box className='svgIcon'>
                <UsersSVG customStroke={palette.secondary[600]}/>
            </Box>
            <Typography variant='pageHeaderTitle' className='headerText'>{t('users.title')}</Typography>
        </Box>
    );
}
